const fromByteToHex = (byte) => {
  if (!Number.isSafeInteger(byte)) {
    return '';
  }

  if (byte < 0 || byte > 255) {
    return '';
  }

  return byte.toString(16).padStart(2, '0');
};

// noinspection JSUnusedGlobalSymbols
export default fromByteToHex;
